import noop from 'lodash/noop';
import React, { useContext } from 'react';

export const TrackingContext = React.createContext({ trackEvent: noop });

export function useTracking() {
  return useContext(TrackingContext);
}
